module.exports = __webpack_public_path__ + "static/media/Project1_Fig12.45b31aa2.png";